import type { EpicRunBoss } from "../../types/epicLeaderboard";
import "./epicLeaderboard.css";

type Props = {
  bosses: EpicRunBoss[];
};

// The bosses killed in a run, as small muted pills ("Lizaan ×2" when killed
// more than once). Renders nothing for a run without boss kills.
const BossChips = ({ bosses }: Props) => {
  if (bosses.length === 0) return null;
  return (
    <ul className="epic-lb-boss-chips" aria-label="Bosses killed">
      {bosses.map((boss) => (
        <li key={boss.name} className="epic-lb-boss-chip">
          {boss.count > 1 ? `${boss.name} ×${boss.count}` : boss.name}
        </li>
      ))}
    </ul>
  );
};

export default BossChips;
